/**
 * Core CRM stage defaults (merged with API documents by slug).
 * Order in the UI follows each stage's persisted `order` from the API (Manage stages).
 */

export const CRM_CORE_STAGES = [
  { slug: 'enquired', name: 'Enquired', order: 0, type: 'enquired', isLocked: true },
  { slug: 'in_progress', name: 'In Progress', order: 1, type: 'in_progress' },
  { slug: 'completed', name: 'Completed', order: 999, type: 'completed', isLocked: true },
  { slug: 'archived', name: 'Archived', order: 1000, type: 'archived', isLocked: true }
];

/**
 * @param {object[]} stages - raw stages from GET /api/crm/stages
 * @returns {object[]} merged with defaults, sorted by `order` for middle stages
 *                      while keeping bookends stable (enquired → middle → completed → archived)
 */
export function normalizeCrmStages(stages = []) {
  const list = Array.isArray(stages) ? stages : [];
  const bySlug = list.reduce((acc, s) => {
    acc[s.slug] = s;
    return acc;
  }, {});

  const mergedCores = CRM_CORE_STAGES.map((core) =>
    bySlug[core.slug] ? { ...core, ...bySlug[core.slug] } : core
  );

  const customStages = list.filter(
    (s) => !CRM_CORE_STAGES.some((c) => c.slug === s.slug) && !s.isArchived
  );

  const nonArchived = [...mergedCores.filter((s) => s.slug !== 'archived'), ...customStages];
  const enquired = nonArchived.find((s) => s.slug === 'enquired');
  const completed = nonArchived.find((s) => s.slug === 'completed');
  const middleStages = nonArchived
    .filter((s) => s.slug !== 'enquired' && s.slug !== 'completed')
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

  const archived = mergedCores.find((s) => s.slug === 'archived');

  return [enquired, ...middleStages, completed, archived].filter(Boolean);
}
